import { Component, forwardRef, Input, Output, EventEmitter, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Service } from '../../class/service';
import { QuickSearch } from '../../class/search';

declare var jQuery: any;

const noop = () => { };
export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QuickSearchComponent),
    multi: true
};

@Component({
    selector: 'quicksearch-component',
    templateUrl: './quick-search.component.html',
    styleUrls: ['./quick-search.component.css'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})

export class QuickSearchComponent implements ControlValueAccessor, AfterViewInit {
    @ViewChild('tpl') tpl;
    @Input() id: string;
    @Input() class: string;
    @Input() required: boolean;
    @Input() quickSearch: QuickSearch;
    @Input() set setData(data: Object) {
        if (data != undefined || data != null) {
            if (data["key"] == '') {
                this.qs = { key: '', value: '' };
            } else {

                this.qs = data;
                this.getList();
            }
        }
    }
    @Output() getData = new EventEmitter<Object>();

    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;
    //get accessor
    get key(): any {
        return this.qs["key"];
    };
    //set accessor including call the onchange callback
    set key(v: any) {
        if (v !== this.qs["key"]) {
            this.qs["key"] = v;
            this.onChangeCallback(v);
        }
    }
    //Set touched on blur
    onBlur() {
        if ((this.qs["key"] == undefined || this.qs["key"] == '') || (this.qs["value"] == undefined || this.qs["value"] == '')) {
            this.qs["key"] = "";
            this.qs["value"] = "";
            this.getData.emit({ data: {} });
        }
        this.onTouchedCallback();
    }
    //From ControlValueAccessor interface
    writeValue(key: any) {
        if (key !== this.qs["key"]) {
            this.qs["key"] = key;
        }
    }
    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
    private qsKey = new FormControl();
    private qs: Object = { key: '', value: '' };
    private loader: boolean = false;
    private open: boolean = false;

    constructor(private service: Service, private _vcr: ViewContainerRef) {
        this.open = false;
    }
    ngAfterViewInit() {
        this._vcr.createEmbeddedView(this.tpl);
    }
    private getList(): void {
        this.loader = !this.loader;
        this.service.GET(this.quickSearch.search.service, "&search=" + (this.qs["key"] || ''))
            .subscribe(res => {
                let data = [];
                data = res["data"]["data"];
                if (data.length == 1) {
                    let i = 0;
                    this.quickSearch.search.column.forEach(element => {
                        if (i == 0) {
                            this.qs["key"] = data[0][element.name];
                            i++;
                        } else if (i == 1) {
                            this.qs["value"] = data[0][element.name];
                            return;
                        }
                    });
                    this.getData.emit({
                        data: data[0]
                    });
                } else {
                    this.quickSearch.search.toSearch = this.qs["key"];
                    this.open = true;
                }

                this.loader = !this.loader;
            }, err => {
                console.log(err);
                this.loader = !this.loader;
            });
    }
    private getData_(data: Object): void {
        this.open = false;
        let i = 0;
        this.quickSearch.search.column.forEach(element => {
            if (i == 0) {
                this.qs["key"] = data["data"][element.name];
                i++;
            } else if (i == 1) {
                this.qs["value"] = data["data"][element.name];
            }
        });
        this.getData.emit(data);
    }
    private keyEvents(event: any) {
        if (event['key'] == 'Enter') {
            if (this.qs["key"] == '') {
                this.qs["key"] = "";
                this.qs["value"] = "";
                this.getData.emit({ data: {} });
            } else {
                this.getList();
            }
        } else if (event['key'] == 'F2') {
            this.open = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/component/quick-search/quick-search.component.ts